// extracted by mini-css-extract-plugin
export default {"container":"op-z","brandName":"pp-z","productName":"qp-z","productNamePdpEnhancements":"rp-z","breakLongProductName":"sp-z"};